"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.stddev = exports.average = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var average = values => values.length ? (0, _reduce.default)(values).call(values, (a, b) => a + b, 0) / values.length : undefined;
exports.average = average;
var stddev = values => {
  if (!values.length) {
    return undefined;
  }
  var avg = average(values);
  return Math.sqrt(average((0, _map.default)(values).call(values, value => (value - avg) ** 2)));
};
exports.stddev = stddev;